import { StructuredOutputDto } from '@shared/services/apiService/apiService';

export const getPrimaryCampaignStructuredOutput = (
  structuredOutputs: StructuredOutputDto[] | undefined,
) => ({
  primaryStructuredOutput: structuredOutputs?.[0] ?? null,
  hasMultipleStructuredOutputs: (structuredOutputs?.length ?? 0) > 1,
});
